"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.checkboxTheme = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Checkbox = ({
  name,
  value,
  text,
  required,
  setValue,
  small,
  classes
}) => _react.default.createElement("label", {
  className: (0, _classnames.default)(classes.label, 'form-checkitem', {
    [classes.small]: small
  }),
  htmlFor: name
}, _react.default.createElement("input", {
  type: "checkbox",
  name: name,
  className: classes.input,
  id: name,
  checked: value,
  onChange: e => setValue(name, e.target.checked, required)
}), " ", text);

Checkbox.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  required: _propTypes.default.bool,
  text: _propTypes.default.node,
  small: _propTypes.default.bool,
  setValue: _propTypes.default.func.isRequired
};

const checkboxTheme = theme => ({
  label: {
    display: 'block',
    position: 'relative',
    textAlign: 'left',
    cursor: 'pointer'
  },
  input: {
    margin: '0 10px 0 0',
    position: 'relative',
    outline: 'none',
    transform: 'translateY(-5px)',
    minWidth: 18,
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: 14,
      height: 14,
      verticalAlign: 'baseline',
      top: 0,
      left: 0,
      backgroundColor: theme.colors.inputBg !== 'transparent' ? theme.colors.inputBg : 'white',
      cursor: 'pointer',
      border: "2px solid ".concat(theme.colors.inputBorder),
      borderRadius: 2
    },
    '&:checked': {
      '&::before': {
        backgroundColor: theme.colors.accent,
        border: "2px solid ".concat(theme.colors.accent)
      },
      '&::after': {
        content: '"✓"',
        display: 'block',
        fontFamily: 'monospace',
        position: 'absolute',
        width: 16,
        height: 16,
        lineHeight: '16px',
        top: 1,
        left: 1,
        fontSize: 18,
        textAlign: 'center',
        color: 'white',
        cursor: 'pointer'
      }
    }
  },
  small: {
    fontSize: theme.typography.inputFontSize - 4,
    lineHeight: 18,
    '& $input': {
      transform: 'translateY(-2px)'
    }
  }
});

exports.checkboxTheme = checkboxTheme;

var _default = (0, _.withFormControl)((0, _reactJss.default)(checkboxTheme)(Checkbox));

exports.default = _default;